fragment ClientUploadConfig on Client {
    mastheadUploadConfig {
        action
        filePrefix
        postData
    }
}
